export default __webpack_public_path__ + "static/textAndImage_subtitle-9804a80619bc5d1a87fc8b780deb3b36.png";